import React from "react";
import { useTranslation } from "react-i18next";
import "./Impressum.css";

const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div className="impressum-container">
      <h1>{t("impressum.title")}</h1>

      <h2>{t("impressum.responsible_persons")}</h2>
      <p>
        Nikolaus Brissa
        <br />
        Lorin Urbantat
      </p>

      <h2>{t("impressum.contact")}</h2>
      <p>
        {t("impressum.email")}:{" "}
        <a href="mailto:support@flateroo.com">support@flateroo.com</a>
        <br />
        {t("impressum.website")}:{" "}
        <a
          href="https://flateroo.com"
          rel="external nofollow noopener"
          target="_blank"
        >
          https://flateroo.com
        </a>
      </p>
    </div>
  );
};

export default Impressum;
